/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Option } from "@nordcloud/gnui/dist/components/dropdown/types";
import { Dropdown, Text } from "@nordcloud/gnui";
import { InlineEditForm } from "~/components/InlineEdit/InlineEditForm";

type Props = {
  name: string;
  options: Option[];
  defaultValue: string;
  display?: React.ReactNode;
  onSubmit: (value: string) => Promise<void>;
  canEdit?: boolean;
  width?: string;
  clearable?: boolean;
  color?: string;
};

function InlineEditDropdown({
  name,
  options,
  defaultValue,
  display,
  onSubmit,
  canEdit,
  width = "100%",
  clearable = false,
  color = "inherit",
}: Props) {
  const [value, setValue] = React.useState(defaultValue);

  React.useEffect(() => {
    setValue(defaultValue);
  }, [setValue, defaultValue]);

  const optionsArray = options.map((opt) =>
    typeof opt === "string" ? { label: opt, value: opt } : opt
  );

  const clear = async () => onSubmit("");

  const defaultDisplay = (
    <Text m="0" color={color}>
      {optionsArray.find((o) => o.value === defaultValue)?.label || "–"}
    </Text>
  );

  return (
    <InlineEditForm
      onSubmit={async () => onSubmit(value)}
      display={display || defaultDisplay}
      canEdit={canEdit}
      width={width}
      onClear={clearable && defaultValue ? clear : undefined}
    >
      <Dropdown
        name={name}
        options={options}
        value={value}
        onChange={(c: string) => setValue(c)}
        minNumOfOptionsToShowSearchBox={6}
        css={{ width: "20rem" }}
      />
    </InlineEditForm>
  );
}

export { InlineEditDropdown };
